import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "row"
}
const _hoisted_2 = { class: "col-12 col-xl-4 order-lg-last" }
const _hoisted_3 = { class: "mb-3" }
const _hoisted_4 = { class: "col-12 mb-3 text-center" }
const _hoisted_5 = { class: "col-12 mb-3 text-center" }
const _hoisted_6 = { class: "col-12 mb-3 text-center" }
const _hoisted_7 = ["href"]
const _hoisted_8 = { class: "col-12 col-xl-8 mb-3 mb-xl-0" }
const _hoisted_9 = { class: "mb-3" }
const _hoisted_10 = { class: "mb-3" }
const _hoisted_11 = { class: "mb-3" }
const _hoisted_12 = { class: "mb-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_profile_card = _resolveComponent("profile-card")!
  const _component_personal_info = _resolveComponent("personal-info")!
  const _component_btc_wallet = _resolveComponent("btc-wallet")!
  const _component_contact = _resolveComponent("contact")!
  const _component_profile_address = _resolveComponent("profile-address")!
  const _component_change_password_modal = _resolveComponent("change-password-modal")!
  const _component_code_confirmation_modal = _resolveComponent("code-confirmation-modal")!
  const _component_information_modal = _resolveComponent("information-modal")!
  const _component_error_modal = _resolveComponent("error-modal")!
  const _component_profile_picture_gallery_modal = _resolveComponent("profile-picture-gallery-modal")!

  return (_ctx.localUserProfileData)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            (_ctx.userCardData)
              ? (_openBlock(), _createBlock(_component_profile_card, {
                  key: 0,
                  user: _ctx.userCardData
                }, null, 8, ["user"]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("button", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showChangePasswordModal())),
              type: "button",
              class: "btn btn-secondary"
            }, [...(_cache[2] || (_cache[2] = [
              _createElementVNode("i", { class: "fas fa-key me-2" }, null, -1),
              _createTextVNode("Cambiar Contraseña ", -1)
            ]))])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("button", {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showChangeProfilePicModal())),
              type: "button",
              class: "btn btn-secondary"
            }, [...(_cache[3] || (_cache[3] = [
              _createElementVNode("i", { class: "fas fa-camera me-2" }, null, -1),
              _createTextVNode("Cambiar Foto de Perfil ", -1)
            ]))])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("a", {
              class: "btn btn-info text-white",
              href: 'https://t.me/' + _ctx.getTelegramBotUsername,
              target: "_blank"
            }, [...(_cache[4] || (_cache[4] = [
              _createElementVNode("i", { class: "fab fa-telegram-plane fa-fw me-1" }, null, -1),
              _createTextVNode("Telegram Bot", -1),
              _createElementVNode("i", { class: "fas fa-robot fa-fw ms-2" }, null, -1)
            ]))], 8, _hoisted_7)
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_personal_info, {
              personalInfo: _ctx.localUserProfileData.personal
            }, null, 8, ["personalInfo"])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_btc_wallet, {
              financialInfo: _ctx.localUserProfileData.financial,
              updated: _ctx.updated,
              error: _ctx.error,
              "cc-modal-status": _ctx.codeConfirmationModalStatus,
              onSaveSecuredData: _ctx.saveSecuredData
            }, null, 8, ["financialInfo", "updated", "error", "cc-modal-status", "onSaveSecuredData"])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_contact, {
              contactInfo: _ctx.localUserProfileData?.contact,
              "registration-date": _ctx.localUserProfileData?.metadata?.creationTime,
              updated: _ctx.updated,
              "cc-modal-status": _ctx.codeConfirmationModalStatus,
              error: _ctx.error,
              onSaveSecuredData: _ctx.saveSecuredData,
              onError: _ctx.showError
            }, null, 8, ["contactInfo", "registration-date", "updated", "cc-modal-status", "error", "onSaveSecuredData", "onError"])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_component_profile_address, {
              addressInfo: _ctx.localUserProfileData?.address
            }, null, 8, ["addressInfo"])
          ])
        ]),
        _createVNode(_component_change_password_modal, {
          onError: _ctx.showError,
          onPasswordChanged: _ctx.showInformation
        }, null, 8, ["onError", "onPasswordChanged"]),
        _createVNode(_component_code_confirmation_modal, {
          requestTag: _ctx.securedDataRequest.requestTag || '',
          errorMessage: _ctx.errorMessage,
          updated: _ctx.updated,
          onProcessSecuredData: _ctx.processSecuredData,
          onClosed: _ctx.cancelSecuredData
        }, null, 8, ["requestTag", "errorMessage", "updated", "onProcessSecuredData", "onClosed"]),
        _createVNode(_component_information_modal, {
          title: _ctx.informationTitle,
          message: _ctx.informationMessage
        }, null, 8, ["title", "message"]),
        _createVNode(_component_error_modal, {
          title: _ctx.errorTitle,
          message: _ctx.errorMessage
        }, null, 8, ["title", "message"]),
        _createVNode(_component_profile_picture_gallery_modal)
      ]))
    : _createCommentVNode("", true)
}